import {View, Text, TouchableOpacity} from 'react-native';
import React, {useEffect, useState} from 'react';
import {Colors} from '../../../../constants/Colors';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {styles} from './styles';
import AntDesign from 'react-native-vector-icons/AntDesign';
import {ISolicitation} from '../../../../types/Equipaments';
import EquipamentModal from '../EquipamentModal/EquipamentModal';

interface IEquipamentCard {
  name: string;
  date: string;
  status: string;
  onPress: () => void;
  item: ISolicitation;
}

const EquipamentCard = ({
  name,
  date,
  onPress,
  status,
  item,
}: IEquipamentCard) => {
  const [showOrdersModal, setShowOrdersModal] = useState<boolean>(false);
  const [showNfModal, setShowNfModal] = useState<boolean>(false);
  const [showTransitModal, setShowTransitModal] = useState<boolean>(false);
  const [drop, setDrop] = useState<boolean>(false);

  const orderSteps = [
    'SOLICITACAO ABERTA',
    'APROVADO',
    'FATURADO',
    'COMODATO GERADO',
    'ENTREGUE',
    'CONCLUÍDO',
  ];

  const handleOpenOrdersModal = (step: string) => {
    if (step === 'cor_solicit') {
      setShowOrdersModal(true);
    }
    // if (step === 'cor_faturado') {
    //   setShowNfModal(true);
    // }
    // if (step === 'cor_encaminhado') {
    //   setShowTransitModal(true);
    // }
  };

  const handleCloseOrdersModal = () => {
    setShowOrdersModal(false);
  };

  const newOrderSteps = [
    {
      name: 'cor_solicit',
      status: item?.cor_solicit,
    },
    {
      name: 'cor_analise',
      status: item?.cor_analise,
    },
    {
      name: 'cor_faturado',
      status: item?.cor_faturado,
    },
    {
      name: 'cor_comodato',
      status: item?.cor_comodato,
    },
    {
      name: 'cor_entregue',
      status: item?.cor_entregue,
    },
    {
      name: 'cor_final',
      status: item?.cor_final,
    },
  ];

  const returnFormattedStatus = {
    cor_solicit: 'Solicitação aberta',
    cor_analise: 'Aprovado',
    cor_faturado: 'Faturado',
    cor_comodato: 'Comodato Gerado',
    cor_entregue: 'Entregue',
    cor_final: 'Concluído',
  };

  const currentIndex = orderSteps.indexOf(status);

  return (
    <View style={styles.CardContainer}>
      <View style={styles.CardContent}>
        <View style={{}}>
          <Text style={styles.label}>Solicitação: {item.MATNR}</Text>
          <View style={styles.ContainerDate}>
            <Text style={styles.preDate}>Data: </Text>
            <Text style={styles.dateText}>{date}</Text>
          </View>
        </View>
        {drop ? (
          <FontAwesome
            name="angle-up"
            size={26}
            color={Colors.RedPallete.red}
          />
        ) : (
          <FontAwesome name="angle-right" size={26} />
        )}
      </View>
      {newOrderSteps &&
        newOrderSteps?.map((step, index) => {
          const isCompleted = index <= currentIndex;
          return (
            <TouchableOpacity
              onPress={() => handleOpenOrdersModal(step?.name)}
              style={
                index === orderSteps.length - 1
                  ? {...styles.progress}
                  : {...styles.progress, borderLeftWidth: 2}
              }>
              {step?.name === 'cor_solicit' && (
                <FontAwesome
                  name="angle-right"
                  size={26}
                  style={{
                    position: 'absolute',
                    right: 0,
                    color: Colors.GrayPallete.lightGrayFour,
                  }}
                />
              )}
              {/* {step?.name === 'cor_faturado' && (
                <FontAwesome
                  name="angle-right"
                  size={26}
                  style={{position: 'absolute', right: 0}}
                />
              )}
              {step?.name === 'cor_entregue' && (
                <FontAwesome
                  name="angle-right"
                  size={26}
                  style={{position: 'absolute', right: 0}}
                />
              )} */}
              <View style={styles.Check}>
                {step.status === 'success' ? (
                  <AntDesign
                    name="checkcircle"
                    size={20}
                    color={Colors.GreenPallete.greenOne}
                  />
                ) : step.status === 'warning' || step.status === 'danger' ? (
                  <AntDesign
                    name="closecircle"
                    size={22}
                    color={Colors.RedPallete.red}
                  />
                ) : (
                  <FontAwesome
                    name="circle-o"
                    size={24}
                    color={Colors.GrayPallete.lightgrayTwo}
                  />
                )}
              </View>

              <Text
                style={
                  step.status === 'success'
                    ? {...styles.OrderText}
                    : {...styles.OrderTextGray}
                }>
                {returnFormattedStatus[step.name]}
              </Text>
            </TouchableOpacity>
          );
        })}
      <EquipamentModal
        returnSort={(val: string) => returnSort(val)}
        item={item}
        visible={showOrdersModal}
        onRequestClose={handleCloseOrdersModal}
      />
      {/* <NFModal
        item={item}
        visible={showNfModal}
        onRequestClose={() => setShowNfModal(false)}
      />
      <TransitModal
        item={item}
        visible={showTransitModal}
        onRequestClose={() => setShowTransitModal(false)}
      /> */}
    </View>
  );
};

export default EquipamentCard;
